module.exports = __webpack_public_path__ + "img/back02.bce37434.jpg";